module.exports = __webpack_public_path__ + "static/media/iSupportLogo.d3ee970c.png";